<script setup lang="ts">
/* eslint-disable */
// @ts-nocheck
import { defineProps, withDefaults } from "vue";

withDefaults(
  defineProps<{
    width?: string;
  }>(),
  {
    width: "310px",
  }
);
</script>

<template>
  <div class="title-divider mt-1" :style="{ width }" role="presentation" aria-hidden="true">
    <i class="bi bi-stars"></i>
  </div>
</template>

<style scoped lang="scss">
@import "@/assets/styles/bootstrap/variables";

.title-divider {
  display: flex;
  align-items: center;
  gap: 10px;
  max-width: 100%;
  margin-inline: auto;
  color: $primary;

  &::before,
  &::after {
    content: "";
    flex: 1;
    height: 1px;
    background: linear-gradient(90deg, transparent, rgba($primary, 0.7));
  }

  &::after {
    transform: scaleX(-1);
  }

  .bi {
    flex: 0 0 auto;
    font-size: 14px;
    line-height: 1;
  }
}

[data-bs-theme="dark"] .title-divider {
  color: $secondary;

  &::before,
  &::after {
    background: linear-gradient(90deg, transparent, rgba($secondary, 0.7));
  }
}
</style>
